const img = '';

export default [
  {
    img: img,
    title: '2001',
    description: `First met at our dad’s corporate family gathering`,
  },
  {
    img: img,
    title: 'March 2019',
    description: `Reunited while being miles apart`,
  },
  {
    img: img,
    title: 'December 2019',
    description: `She went home for good, they started dating`,
  },
  {
    img: img,
    title: 'January 2023',
    description: `He popped the question, she said yes`,
  },
  {
    img: img,
    title: 'May 2023',
    description: `Officially fiancé & fiancée`,
  },
  {
    img: img,
    title: 'December 2024',
    description: `The two finally become one`,
  },
];
